import { render, staticRenderFns } from "./UpgradeBanner.vue?vue&type=template&id=7aeefcdc&"
import script from "./UpgradeBanner.vue?vue&type=script&lang=js&"
export * from "./UpgradeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aeefcdc')) {
      api.createRecord('7aeefcdc', component.options)
    } else {
      api.reload('7aeefcdc', component.options)
    }
    module.hot.accept("./UpgradeBanner.vue?vue&type=template&id=7aeefcdc&", function () {
      api.rerender('7aeefcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/app/UpgradeBanner.vue"
export default component.exports